import { MobileOdd } from "./FootballOddsTrendOdds";

export default function MobileOddsSlide({ rows }) {
  return (
    <div className="w-full shrink-0 snap-start px-1">
      <div className="flex flex-col gap-1">
        {rows.map((row) => (
          <div
            key={row.label}
            className="grid grid-cols-[45px_95px] items-center gap-2"
          >
            <div className="text-left text-[9px] leading-[10px] text-[var(--theme-text-muted)]">
              {row.label}
            </div>
            <div className="flex items-center justify-between gap-2 text-[11px] leading-[14px] tabular-nums">
              <MobileOdd value={row.a} trend={row.aTrend} />
              <span className="text-[var(--theme-highlight,#0B71F9)]">
                {row.b}
              </span>
              <MobileOdd value={row.c} trend={row.cTrend} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

